// Script JS VOLO TSARA (Shopify Version)

document.addEventListener('DOMContentLoaded', () => {

  // --- BURGER MENU LOGIC ---
  const burger = document.querySelector('.burger');
  const nav = document.querySelector('.nav-links');
  const closeMenu = document.querySelector('.close-menu');
  const navLinks = document.querySelectorAll('.nav-links li');

  if (burger) {
    burger.addEventListener('click', () => {
      nav.classList.add('active');
    });
  }

  if (closeMenu) {
    closeMenu.addEventListener('click', () => {
      nav.classList.remove('active');
    });
  }

  navLinks.forEach(link => {
    link.addEventListener('click', () => {
      if (nav.classList.contains('active')) {
        nav.classList.remove('active');
        burger.classList.remove('toggle');
      }
    });
  });

  // --- QUANTITY LOGIC (Shopify) ---
  const qtySelectors = document.querySelectorAll('.quantity-selector');
  qtySelectors.forEach(selector => {
    const minusBtn = selector.querySelector('.minus');
    const plusBtn = selector.querySelector('.plus');
    const input = selector.querySelector('input');

    if (minusBtn && plusBtn && input) {
      minusBtn.addEventListener('click', () => {
        let val = parseInt(input.value);
        if (val > 1) {
          input.value = val - 1;
          input.dispatchEvent(new Event('change'));
        }
      });
      plusBtn.addEventListener('click', () => {
        let val = parseInt(input.value);
        input.value = val + 1;
        input.dispatchEvent(new Event('change'));
      });
    }
  });

  // --- GALLERY LOGIC ---
  const thumbnails = document.querySelectorAll('.thumbnails img');
  const mainImage = document.querySelector('.main-image img');

  if (thumbnails.length > 0 && mainImage) {
    thumbnails.forEach(thumb => {
      thumb.addEventListener('click', function() {
        thumbnails.forEach(t => t.classList.remove('active'));
        this.classList.add('active');
        mainImage.style.opacity = '0';
        setTimeout(() => {
          mainImage.src = this.src;
          mainImage.style.opacity = '1';
        }, 200);
      });
    });
  }

  // --- SMOOTH SCROLL ---
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const href = this.getAttribute('href');
      if(href !== '#' && href.startsWith('#')) {
        const target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }
    });
  });
});
